import React, { memo, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../store";
import SearchDataChart from "./SearchDataChart";
import { getSearchNameInfo, setSearchNameInfo } from "../slices/storeSlice";
import Swal from "sweetalert2";
import globalValues from "../store/globalValues";

//region style
const Container = styled.div`
    z-index: 999;
    top: 0;
    position: fixed;
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 80%,
        rgba(255, 255, 255, 0) 100%
    );
    width: 100%;
    padding-bottom: 5px;
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                padding-top: 0;
                position: relative;
                width: 95%;
            `;
        } else {
            return css`
                padding-top: 30px;
            `;
        }
    }}
`;

const GreenSearchBarContainer = styled.div`
    padding: 10px;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                border-radius: 20px;
                padding: 15px 10px;
                background-color: #0e8066;
                p {
                    font-size: 20px;
                    padding: 12px 5%;
                    color: white;
                    display: block;
                    margin: 0 0 10px 0;
                }
            `;
        }
    }}
`;

const GreenSearchBar = styled.div`
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css``;
        } else {
            return css`
                height: 120px;
                border-radius: 60px;
                box-shadow: 0 30px 40px white;
                background-color: #0e8066;
                p {
                    color: white;
                    display: block;
                    margin: 0 0 10px 0;
                }
            `;
        }
    }}
    width: 100%;

    display: flex;
    font-size: 18px;
    line-height: initial;
`;

const InputNameDiv = styled.div`
    padding-left: 5%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const FamilyGivenNameDiv = styled.div`
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                display: flex;
                flex-direction: column;
            `;
        }
    }}
`;

const SearchBarInputBox = styled.input`
    height: 48px;
    font-family: -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft JhengHei UI", "Microsoft YaHei",
        "細明體_HKSCS", "Kai_MSCS", "Ming_MSCS", "Ming-MSCS-DSI";
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                width: 88%;
                margin-bottom: 10px;
            `;
        } else {
            return css`
                width: 45%;
            `;
        }
    }}

    border-radius: 10px;
    border: none;
    padding-left: 28px;
    font-size: 16px;
    font-weight: bold;
    margin-right: 14px;
    :focus-visible {
        outline: 2px dashed #cae7e2;
        border-radius: 10px;
    }
`;

const SelectPeriodDiv = styled.div`
    padding-right: 5%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const SearchBarYearSelecter = styled.select`
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                width: 88%;
            `;
        } else {
            return css`
                width: 100%;
            `;
        }
    }}
    height: 48px;
    border-radius: 10px;
    border: none;
    font-size: 18px;
    font-weight: bold;
    padding-left: 32px;
    background: url("${process.env.PUBLIC_URL}/images/arrow.png") no-repeat scroll right center white;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    :focus-visible {
        outline: 2px dashed #cae7e2;
        border-radius: 10px;
    }
`;

const YearSelecterContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const FBbuttonContainer = styled.div`
    align-self: center;
    margin-left: auto;
    margin-right: 30px;
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                margin-right: 20px;
            `;
        } else {
            return css`
                transform: scale(1.2, 1.2);
            `;
        }
    }}
`;

const SearchIcon = styled.div`
    flex: 0 0 auto;
    background-image: url("${process.env.PUBLIC_URL}/images/00-spotlight.png");
    width: 90px;
    height: 90px;
    background-size: cover;
    cursor: pointer;
    margin: auto 20px auto auto;
`;
//#cae7e2
//background-color: #2ab193;
//
const ChartBG = styled.div`
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css``;
        } else {
            return css`
                width: 820px;
            `;
        }
    }}
`;

const BGTopLayer = styled.div`
    display: flex;
    width: 100%;
`;

const BGTriangle = styled.div`
    background-color: #2ab193;
    width: 90px;
    height: 90px;
    -webkit-clip-path: polygon(0 0, 0% 100%, 100% 100%);
    clip-path: polygon(0 0, 0% 100%, 100% 100%);
    transform: translateY(1px);
`;

const BGSquare = styled.div`
    display: flex;
    align-items: center;
    background-color: #2ab193;
    height: 90px;
    flex: 1;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                padding-left: 20px;
            `;
        } else {
            return css`
                padding-left: 40px;
                padding-top: 10px;
            `;
        }
    }}
`;

const TableContent = styled.div`
    background-color: #2ab193;
    padding: 0 30px 30px 30px;
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css``;
        } else {
            return css`
                width: 820px;
                height: 640px;
            `;
        }
    }}
`;

const CloseClick = styled.div`
    background-image: url("${process.env.PUBLIC_URL}/images/popUp-close.png");
    width: 20px;
    height: 20px;
    background-size: cover;
    cursor: pointer;
    align-self: center;
`;

const ChartContainer = styled.div`
    z-index: 999;
    //position: absolute;
    transition: 0.3s all ease-in-out;
    //left: 50%;
    //transform: translateX(-50%);
    background-color: white;
    box-shadow: 0 -5px 40px rgba(0, 0, 0, 0.3);
    flex: 1;
    overflow: auto;
    border-radius: 5px;
    overscroll-behavior: contain;
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                top: 5%;
                min-width: 300px;
                min-height: 300px;
                width: calc(100% - 40px);
                margin-left: 20px;
                margin-right: 20px;
            `;
        } else {
            return css`
                top: 5vh;
                max-width: 980px;
                min-height: 300px;
                max-height: 90%;
            `;
        }
    }}
`;

const Mask = styled.div`
    background-color: rgba(255, 255, 255, 0.5);
    overflow: hidden;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 998;
    display: block;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(6px);
    transition: 0.3s all ease-in-out;
`;

const ResultYearSelector = styled.select`
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    select::-ms-expand {
        display: none;
    }
    border: none;
    color: white;
    background-color: rgb(4, 106, 92);
    background: url("${process.env.PUBLIC_URL}/images/arrow2.png") 90% 50% no-repeat scroll rgb(4, 106, 92);

    height: 40px;
    border-radius: 30px;
    font-size: 30px;
    padding: 1px 0 0 25px;
    display: flex;
    text-align: left;

    flex: 1;
    :focus-visible {
        outline: 2px dashed #cae7e2;
        border-radius: 30px;
    }
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                max-width: 180px;
                width: 120px;
                margin-right: 10px;
            `;
        } else {
            return css`
                width: 180px;
                max-width: 180px;
            `;
        }
    }}
`;

const ChartTopBar = styled.div`
    display: flex;
    height: 40px;
    margin-top: 35px;
    padding: 0px 50px 0 50px;
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                padding: 0 20px 0px 20px;
            `;
        } else {
            return css``;
        }
    }}
`;
//endregion

function SearchBar(props: any) {
    const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
    const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);

    const dispatch: AppDispatch = useDispatch();
    const Min = globalValues.minYear;
    const Max = globalValues.maxYear;

    const search = window.location.search;
    const qs = require("qs");
    const { FamilyName, GivenName, Year } = qs.parse(search.replace(/^\?/, ""));
    const [DisplayClassName, setDisplayClassName] = useState("Off");
    const [familyName, setFamilyName] = useState<any>(FamilyName || "");
    const [name, setName] = useState<any>(GivenName || "");
    const [year, setYear] = useState<any>(Year || "");

    function isChinese(input: string): boolean {
        return /[\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF\u{20000}-\u{2A6DF}]/u.test(input);
    }

    // function isChinese(input: string) {
    //   const pattern = new RegExp("[\u4E00-\u9FFF]");
    //   const pattern0 = new RegExp("[\u3000-\u4DFF]");
    //   const pattern2 = new RegExp("[\uE007-\uF6E0]");
    //
    //   let i = 0;
    //   let result = false;
    //   while (i < [...input].length) {
    //     if (pattern.test([...input][i])){
    //       i++
    //     }
    //     else if (pattern0.test([...input][i])){
    //       i++
    //     }
    //     else if (pattern2.test([...input][i])){
    //       i++
    //     }
    //     else
    //       return result
    //   }
    //   result = true
    //   return result
    //
    //   //if(pattern.test(input))
    //   //  return true //中文
    //   //return false //不是中文
    // }

    const Options = () => {
        let Result = [];
        Result.push(
            <option key={0} value="" disabled hidden>
                請選擇年份
            </option>,
        );
        for (let i = Max; i >= Min; i--) {
            Result.push(
                <option key={i} value={i}>
                    {i}
                </option>,
            );
        }
        return <>{Result}</>;
    };

    const YearChangeOptions = () => {
        let Result = [];

        for (let i = Max; i >= Min; i--) {
            Result.push(
                <option key={i} value={i}>
                    {i}年
                </option>,
            );
        }
        return <>{Result}</>;
    };

    const Toast = Swal.mixin({
        toast: false,
        showCloseButton: true,
        target: "root",
        position: "center",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener("mousedown", Swal.clickConfirm);
        },
    });

    function customAlert(text: string) {
        Toast.fire({
            icon: "warning",
            title: text,
        });
    }

    const open = () => {
        if (!isChinese(familyName)) {
            if (isMobile || isTablet) {
                alert("請輸入中文姓氏");
            } else {
                customAlert("請輸入中文姓氏");
            }
            document.getElementById("FamilyName")?.focus();
        } else if (!isChinese(name)) {
            if (isMobile || isTablet) {
                alert("請輸入中文名字");
            } else {
                customAlert("請輸入中文名字");
            }

            document.getElementById("GivenName")?.focus();
        } else if (familyName.length + name.length === 0) {
            if (isMobile || isTablet) {
                alert("請輸入姓氏或名字");
            } else {
                customAlert("請輸入姓氏或名字");
            }
            document.getElementById("FamilyName")?.focus();
        } else if (year === "") {
            if (isMobile || isTablet) {
                alert("請選擇時期");
            } else {
                customAlert("請選擇時期");
            }
            document.getElementById("YearSelecter1")?.focus();
        } else if (parseInt(year) > Max || parseInt(year) < Min) {
            if (isMobile || isTablet) {
                alert("請選擇正確時期");
            } else {
                customAlert("請選擇正確時期");
            }
            document.getElementById("YearSelecter1")?.focus();
        } else if (familyName.length + name.length > 9 || familyName.length > 5 || name.length > 6) {
            if (isMobile || isTablet) {
                alert("請檢查姓名及名字長度");
            } else {
                customAlert("請檢查姓名及名字長度");
            }
            document.getElementById("FamilyName")?.focus();
        } else {
            dispatch(getSearchNameInfo({ year: year, familyName: familyName, name: name }));
            setDisplayClassName("On");
        }
    };

    const close = () => {
        setDisplayClassName("Off");
        dispatch(setSearchNameInfo(null));
    };

    const changeYear = (targetValue: any) => {
        setYear(targetValue);
        dispatch(getSearchNameInfo({ year: targetValue, familyName: familyName, name: name }));
    };

    window.onkeydown = function (e) {
        if (e.key == "Enter") {
            open();
        }
    };

    let origin = window.location.origin;
    let URL = "";
    if (familyName != "" && name != "") {
        URL =
            origin +
            "/" +
            process.env.PUBLIC_URL +
            "?FamilyName=" +
            familyName +
            "&GivenName=" +
            name +
            "&Year=" +
            year;
    } else if (familyName === "") {
        URL = origin + "/" + process.env.PUBLIC_URL + "?GivenName=" + name + "&Year=" + year;
    } else if (name === "") {
        URL = origin + "/" + process.env.PUBLIC_URL + "?FamilyName=" + familyName + "&Year=" + year;
    }

    let encodeURI_url = encodeURIComponent(URL);

    const FBshareButton = () => {
        return (
            <a
                target={"_blank"}
                href={`https://www.facebook.com/sharer.php?t=Macau%20Statistics%20and%20Census%20Service%20(DSEC)&u=${encodeURI_url}`}
            >
                <img className={"fb-icon"} src={`${process.env.PUBLIC_URL}/images/facebook-icon.png`} />
            </a>
        );
    };

    const SearchInput = () => {
        if (isMobile || isTablet) {
            return (
                <GreenSearchBarContainer>
                    <div>
                        <p>請輸入你想統計的名字及年份</p>
                        <GreenSearchBar>
                            <InputNameDiv>
                                <FamilyGivenNameDiv>
                                    <SearchBarInputBox
                                        id="FamilyName"
                                        value={familyName}
                                        onChange={(e) => setFamilyName(e.target.value)}
                                        name="LastName"
                                        type="text"
                                        placeholder="姓"
                                        required
                                    />
                                    <SearchBarInputBox
                                        id="GivenName"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        name="FirstName"
                                        type="text"
                                        placeholder="名"
                                        required
                                    />
                                    <SearchBarYearSelecter
                                        id="YearSelecter1"
                                        value={year}
                                        onChange={(e) => setYear(parseInt(e.target.value))}
                                        required
                                    >
                                        <Options />
                                    </SearchBarYearSelecter>
                                </FamilyGivenNameDiv>
                            </InputNameDiv>
                            <SearchIcon onClick={open} />
                        </GreenSearchBar>
                    </div>
                </GreenSearchBarContainer>
            );
        } else {
            return (
                <GreenSearchBar>
                    <InputNameDiv>
                        <p>請輸入你想統計的名字</p>
                        <FamilyGivenNameDiv>
                            <SearchBarInputBox
                                id="FamilyName"
                                value={familyName}
                                onChange={(e) => setFamilyName(e.target.value)}
                                name="LastName"
                                type="text"
                                placeholder="姓"
                            />
                            <SearchBarInputBox
                                id="GivenName"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                name="FirstName"
                                type="text"
                                placeholder="名"
                            />
                        </FamilyGivenNameDiv>
                    </InputNameDiv>

                    <SelectPeriodDiv>
                        <p>選擇年份</p>
                        <YearSelecterContainer>
                            <SearchBarYearSelecter
                                id="YearSelecter1"
                                value={year}
                                onChange={(e) => setYear(parseInt(e.target.value))}
                                required
                            >
                                <Options />
                            </SearchBarYearSelecter>
                        </YearSelecterContainer>
                    </SelectPeriodDiv>

                    <SearchIcon onClick={open} />
                </GreenSearchBar>
            );
        }
    };

    useEffect(() => {
        if (Year != null && familyName.length + name.length > 0) {
            open();
        }
    }, []);

    const SectionContainer = document.getElementById("fb-root") as HTMLDivElement;
    window.onscroll = function () {
        let top = document.documentElement.scrollTop || document.body.scrollTop;
        if (isMobile || isTablet) {
            if (top >= 150) {
                SectionContainer.classList.remove("On");
                SectionContainer.classList.add("Off");
            } else {
                SectionContainer.classList.remove("Off");
                SectionContainer.classList.add("On");
            }
        }
    };

    return (
        <Container className={"layout-container"} id="fb-root">
            {SearchInput()}
            <div className={`popup-chart-modal ${DisplayClassName}`}>
                <ChartContainer>
                    <ChartTopBar>
                        <ResultYearSelector value={year} onChange={(e) => changeYear(parseInt(e.target.value))}>
                            <YearChangeOptions />
                        </ResultYearSelector>
                        <FBbuttonContainer>
                            <FBshareButton />
                        </FBbuttonContainer>
                        <CloseClick onClick={close} />
                    </ChartTopBar>
                    <SearchDataChart year={year} reset={Math.random()} />
                </ChartContainer>
                <Mask onClick={close} />
            </div>
        </Container>
    );
}

export default memo(SearchBar);
